import { ImageInfoViewer } from 'src/components/image-info-viewer';

export default ImageInfoViewer;
